import App from './App'
import Chef from './Chef'
import Delivery from './Delivery'
import Footer from './Footer'
import Header from './Header'
import HotelContacts from './HotelContacts'
import News from './News'
import NewsItem from './NewsItem'
import RestaurantContacts from './RestaurantContacts'
import RoomsCatalog from './RoomsCatalog'
import SocShare from './SocShare'
import PhotoGallery from './PhotoGallery'
import Breadcrumbs from './Breadcrumbs'
import RoomItem from './RoomItem'
import NotFound from './NotFound'
import SpinButton from './SpinButton'
import Spinner from './Spinner'

export {
  App,
  Chef,
  Delivery,
  Footer,
  Header,
  HotelContacts,
  News,
  NewsItem,
  RestaurantContacts,
  RoomsCatalog,
  SocShare,
  PhotoGallery,
  Breadcrumbs,
  RoomItem,
  NotFound,
  SpinButton,
  Spinner,
}



// WEBPACK FOOTER //
// ./src/components/index.js